// extracted by mini-css-extract-plugin
module.exports = {"setting-item":"setting-item","icon":"icon"};